import request from "../plugins/request";

// 直播地址查询
export const getLiveAddress = (data) => {
  return request({
    url: '/api/device/liveAddress',
    method: 'post',
    data: data
  })
}

// 监控数据区域
export const getOverview = () => {
  return request({
    url: '/api/monitor/overview',
    method: 'get'
  })
}

// 添加设备
export const addDevice = (data) => {
  return request({
    url: '/api/device/add',
    method: 'post',
    data: data
  })
}

// 设备列表
export const getDeviceList = (data) => {
  return request({
    url: '/api/device/list',
    method: 'post',
    data
  })
}

// 区域设备
export const getDeviceTree = (data) => {
  return request({
    url: '/api/device/tree',
    method: 'post',
    data
  })
}

// 编辑设备
export const editDevice = (data) => {
  return request({
    url: '/api/device/update',
    method: 'post',
    data: data
  })
}

// 语音播报
export const playVoice = (data) => {
  return request({
    url: '/api/device/playVoice',
    method: 'post',
    data: data
  })
}
